import React from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell, IconButton, Tooltip, FormControlLabel, Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@totalsoft/rocket-ui';
import { Delete } from '@mui/icons-material';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const EngineExternalSystemListItemComponent = ({
  containerDispatcher,
  item,
  index,
  dictionaryExternalSystemInterrogation,
  validation,
  isReadOnly
}) => {
  const { t } = useTranslation();
  const onPropertyChanged = (property, propertyValue) => {
    containerDispatcher({
      type: 'OnEngineExternalSystemChanged',
      property,
      propertyValue,
      index
    });
  };

  const onDeleteExternalSystem = () => {
    containerDispatcher({
      type: 'OnEngineExternalSystemDeleted',
      engineScoringXExternalSystemId: item.engineScoringXExternalSystemId,
      index
    });
  };

  return (
    <TableRow hover key={index}>
      <TableCell>
        <Autocomplete
          fullWidth
          value={item.externalSystemId}
          simpleValue
          options={dictionaryExternalSystemInterrogation}
          onChange={event => onPropertyChanged('externalSystemId', event)}
          isDisabled={isReadOnly}
          error={!isValid(validation.externalSystemId)}
          helperText={getErrors(validation.externalSystemId)}
        />
      </TableCell>
      <TableCell>
        <FormControlLabel
          control={<Checkbox checked={item.isMandatory} disabled={isReadOnly} />}
          onChange={event => onPropertyChanged('isMandatory', event.target.checked)}
        ></FormControlLabel>
      </TableCell>
      <TableCell>
        <Tooltip title={t('Tooltips.Delete')}>
          <span>
            <IconButton color='primary' onClick={onDeleteExternalSystem} disabled={isReadOnly}>
              <Delete />
            </IconButton>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

EngineExternalSystemListItemComponent.propTypes = {
  containerDispatcher: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  dictionaryExternalSystemInterrogation: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object.isRequired
};
export default EngineExternalSystemListItemComponent;
